
export default {
  methods: {
    generateAltText(device) {
      const { deviceName, deviceTypeDescription, statusMessage } = device;

      let altText = `${deviceName} - ${deviceTypeDescription}`;

      if (statusMessage && statusMessage.message) {
        altText += ` (${statusMessage.message})`;
      }

      return altText;
    },
    isDeviceActive() {
      // TO DO modify this once API returns "real" not mock data and includes this property
      return true;
    },
  }
};
